import React, { useRef, useMemo, useState, useEffect } from 'react'
import { PencilSimpleLine } from 'phosphor-react'

import { Form, FormTextField, useCurrentForm } from '@/components/CoForm'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  FormHelperText,
  IconButton,
  Tooltip,
} from '@material-ui/core'

// import { cpf, placa } from '@/consts/regexp'
// import { toMask } from '@/services/masks'
import { Button } from '@/components'
import { StyledDialogTitle } from '@/components/Dialog/styles'

import { handleValidationError, Yup as y } from '@/services/yup'

import { useDispatch, useSelector } from 'react-redux'
import { updateCollectRequest } from '@/store/modules/users/collections/reducer'
import { toMask } from '@/services/masks'
import { cpf, placa } from '@/consts/regexp'

const EditCollectSchema = y.object().shape({
  vpt_placa: y.string().required(),
  vpt_motorista: y
    .string()
    .required()
    .max(100, 'O nome do motorista, deve conter no maxímo 100 carácteres'),
  vpt_cod_motorista: y.string().required(),
})

// -----------------------------------------------------------

export function CollectQuickFormEdit({ initialData, disabled }) {
  const [dialogOpen, setDialogOpen] = useState(false)

  const isSubmitting = useSelector((state) => state.users.collections.loading)
  const isSubmitted = useSelector((state) => state.users.collections.submitted)

  const dispatch = useDispatch()

  const formRef = useRef(null)

  const defaultValues = useMemo(
    () => ({
      id_coleta: initialData?.id_coleta || '',
      vpt_placa: initialData?.vpt_placa || '',
      vpt_motorista: initialData?.vpt_motorista || '',
      vpt_cod_motorista: initialData?.vpt_cod_motorista || '',
    }),
    [initialData]
  )

  function handleToogleDialogOpen() {
    setDialogOpen(!dialogOpen)
  }

  function handleSubmitButton() {
    formRef.current.setErrors({})

    const data = formRef.current.getValues()
    handleSubmit(data)
  }

  function handleSubmit(data) {
    const formValidator = handleValidationError(formRef.current)

    EditCollectSchema.validate(data, { abortEarly: false })
      .then((data) => {
        dispatch(
          updateCollectRequest({
            id_coleta: data.id_coleta,
            vpt_placa: data.vpt_placa?.toUpperCase(),
            vpt_motorista: data.vpt_motorista,
            vpt_cod_motorista: data.vpt_cod_motorista,
          })
        )
      })
      .catch((errors) => {
        formValidator(errors)
      })
  }

  // function handleChangeDriver(_, driver) {
  //   if (driver) {
  //     formRef.current.setFieldValue('vpt_motorista', driver.label)
  //   }
  // }

  useEffect(() => {
    if (isSubmitted) {
      setDialogOpen(false)
    }
  }, [isSubmitted])

  return (
    <>
      <Tooltip title="Editar">
        <span>
          <IconButton
            onClick={handleToogleDialogOpen}
            color="primary"
            variant="outlined"
            size="medmium"
            disabled={disabled}
          >
            <PencilSimpleLine weight="duotone" />
          </IconButton>
        </span>
      </Tooltip>

      {!disabled && (
        <Dialog fullWidth maxWidth="sm" open={dialogOpen}>
          <Form
            formRef={formRef}
            initialData={defaultValues}
            onSubmit={handleSubmit}
            schema={EditCollectSchema}
          >
            <StyledDialogTitle>Alterar informações da coleta</StyledDialogTitle>

            <DialogContent>
              <Box padding="1rem 0" display="grid" gridGap="1rem">
                <FormTextField
                  fullWidth
                  size="small"
                  name="id_coleta"
                  label="Coleta"
                  variant="standard"
                  disabled
                />

                <FormTextField
                  fullWidth
                  size="small"
                  name="vpt_placa"
                  label="Placa"
                  variant="standard"
                  textMaskProps={toMask(placa.array)}
                />

                <FormTextField
                  fullWidth
                  size="small"
                  label="Nome Motorista"
                  name="vpt_motorista"
                  variant="standard"
                />

                <FormTextField
                  fullWidth
                  size="small"
                  label="Doc. Motorista"
                  name="vpt_cod_motorista"
                  variant="standard"
                  textMaskProps={toMask(cpf.array)}
                />

                <FormErrors />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                type="button"
                variant="outlined"
                color="primary"
                onClick={handleToogleDialogOpen}
              >
                Cancelar
              </Button>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                loading={isSubmitting}
                onClick={handleSubmitButton}
              >
                Salvar
              </Button>
            </DialogActions>
          </Form>
        </Dialog>
      )}
    </>
  )
}

function FormErrors() {
  const { errors } = useCurrentForm()

  if (errors && errors?.vpt_motorista)
    return <FormHelperText error>{errors?.vpt_motorista}</FormHelperText>

  return null
}
